<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-5 col-xs-6 mb-10" v-if="customers.length > 0">
                                    <div class="input-group">
                                        <span class="input-group-addon glyphicon glyphicon-search" id="basic-addon1"></span>
                                        <input type="text" placeholder="Zoek op bedrijfsnaam..." v-model="searchInput" class="form-control">
                                    </div>
                                </div>
                                <div v-if="$can('btonly')" class="pull-right btn btn-success" @click="showAddCustomerModal()">Klant toevoegen</div>
                            </div>
                        </div>
                        <div class="panel" v-if="customers.length > 0">
                            <table class="table">
                                <thead style="font-weight: 600;">
                                    <tr>
                                        <td>Debiteurnummer</td>
                                        <td>Bedrijfsnaam</td>
                                        <td>Adres</td>
                                        <td>Postcode</td>
                                        <td>Plaatsnaam</td>
                                        <td>Telefoon</td>
                                        <td>E-mailadres</td>
                                        <td v-if="$can('btonly')" style="white-space: nowrap">Toon prijzen</td>
                                        <td v-if="$can('btonly')" style="white-space: nowrap">Producten toevoegen</td>
                                        <td v-if="$can('btonly')"></td>
                                        <td v-if="$can('btonly')"></td>
                                        <td v-if="$can('btonly')"></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="customer in filteredCustomers">
                                        <td>{{customer.debtorNumber}}</td>
                                        <td>{{customer.companyName}}</td>
                                        <td>{{customer.address}}</td>
                                        <td>{{customer.zipCode}}</td>
                                        <td>{{customer.city}}</td>
                                        <td>{{customer.phoneNumber}}</td>
                                        <td>{{customer.email}}</td>
                                        <td class="align-middle" v-if="_self.$can('btonly')"><input type="checkbox" v-model="customer.showPrices" @click="toggleCustomerShowPrices(customer.id, customer.showPrices)"></td>
                                        <td class="align-middle" v-if="_self.$can('btonly')"><input type="checkbox" v-model="customer.addProducts" @click="toggleCustomerAddProducts(customer.id, customer.addProducts)"></td>
                                        <td v-if="$can('btonly')"><i class="glyphicon glyphicon-edit" @click="editCustomer(customer.id)"></i></td>
                                        <td v-if="$can('btonly')"><i class="glyphicon glyphicon-trash" @click="deleteCustomer(customer.id)"></i></td>
                                        <td v-if="$can('btonly')"><a href="#" @click="login(customer)">login</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import BtFooter from '../BTFooter.vue'
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'

    export default {
        name: 'Customers',
        components: {
            BtFooter
        },
        created() {
            document.title = 'Brabant-Tools | Klanten'
            this.$store.dispatch('getCustomers')
        },
        data() {
            return {
                searchInput: ''
            }
        },
        methods: {
            getLocale() {
                return this.$i18n.locale
            },
            showAddCustomerModal() {
                this.$modal.show('add-customer-modal')
            },
            editCustomer(customerId) {
                this.$router.push('klanten/' + customerId)
            },
            deleteCustomer(customerId) {
                var _self = this
                this.$swal({
                    title: 'Let op!',
                    text: 'Je staat op het punt om een klant te verwijderen. Deze actie kan niet ongedaan worden!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Verwijderen',
                    cancelButtonText: 'Annuleren'
                }).then((result) => {
                    if (result) {
                        this.$store.dispatch('deleteCustomer', customerId).then(() => {
                            if (this.isCustomerDeleted) {
                                _self.$store.commit(types.REMOVE_CUSTOMER_FROM_CUSTOMERS, customerId)
                            } else {
                                _self.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Deze klant is gekoppeld en kan niet verwijderd worden!' })
                            }
                        })
                    }
                })
            },
            login(customer) {
                this.access = 'customer'
                this.$store.dispatch('logout')
                this.$store.dispatch('login', { email: customer.email, password: customer.debtorNumber }).then(() => {
                    if (this.loggedInCustomer.id) {
                        if (this.loggedInCustomer.email === 'info@brabanttools.nl') {
                            this.access = 'btonly'
                        } else {
                            this.access = 'customer'
                        }
                        this.$store.dispatch('getShoppingCart').then(() => {
                            if (this.productsInShoppingCart.length > 0) {
                                this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id).then(() => {
                                    this.$store.dispatch('getDiscounts').then(() => {
                                        this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS_IN_SHOPPINGCART, this.discounts)
                                        this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                            if (this.customerSpecificPrices) {
                                                this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS_IN_SHOPPINGCART, this.customerSpecificPrices)
                                            }
                                        })
                                        if (this.products) {
                                            this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS, this.discounts)
                                            this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                                if (this.customerSpecificPrices) {
                                                    this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS, this.customerSpecificPrices)
                                                }
                                            })
                                        }
                                    })
                                })
                            }
                        })
                        const path = '/winkelwagen';
                        if (this.$route.path !== path) this.$router.push(path)
                    }
                })
            },
            toggleCustomerShowPrices(customerId, showPrices) {
                console.log('1');
                this.$store.commit(types.SET_CUSTOMER_TO_UPDATE, { customerId: customerId, showPrices: !showPrices })
                this.$store.dispatch('toggleCustomerShowPrices')
            },
            toggleCustomerAddProducts(customerId, addProducts) {
                this.$store.commit(types.SET_CUSTOMER_TO_UPDATE, { customerId: customerId, addProducts: !addProducts })
                this.$store.dispatch('toggleCustomerAddProducts')
            },
        },
        computed: {
            ...mapGetters({
                loggedInCustomer: 'loggedInCustomer',
                productsInShoppingCart: 'productsInShoppingCart',
                discounts: 'discounts',
                customers: 'customers',
                isCustomerDeleted: 'isCustomerDeleted'
            }),
            filteredCustomers() {
                return this.customers.filter(customer => {
                    return customer.companyName.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1
                })
            }
        }
    }
</script>

<style scoped>
    .glyphicon {
        top: 0;
        cursor: pointer;
    }
</style>
